import Api from "../services/ApiManager";
import { Options, execFillRequest } from "./effects";
import { CustomerActionTypes, attachPaymentMethodActionType } from "../../model/customer/actions";
import { call, all, takeLatest } from "redux-saga/effects";
import { attachPaymentMethod } from "../actions/customerActions";

function* attachPayment(action: CustomerActionTypes) {
    const options: Options = {
        payload: [action.payload],
        successMessage: 'Votre moyen de paiement a bien été ajouté',
        forceRefreshKey: 'PaymentMethods'
    }
    yield call(execFillRequest,
        Api.customers.attachPaymentMethods,
        attachPaymentMethod.success,
        attachPaymentMethod.failure,
        options);
}

export function* startAttachPaymentSagas() {
    yield all([
        takeLatest(attachPaymentMethodActionType.request, attachPayment),
    ]);
}
